
import * as THREE from './three/three.module';
import { DDSLoader } from './three/loaders/DDSLoader.js';
import { OBJLoader } from './three/loaders/OBJLoader.js';

var ump3Dintro = {};

ump3Dintro.playAnimation = true;

ump3Dintro.initSceneOne = function () {
    console.log('initSceneOne: ');
    var container;
    var camera, scene, renderer, controls;
    var object01;
    var mesh;
    var windowHalfX = window.innerWidth / 2;
    var windowHalfY = window.innerHeight / 2;

    ump3Dintro.initSceneOne.animate = function () {
        if (ump3Dintro.playAnimation) {
            requestAnimationFrame(ump3Dintro.initSceneOne.animate);
            ump3Dintro.initSceneOne.render();
        }
    };

    ump3Dintro.initSceneOne.render = function () {
        object01.rotation.y += 0.015;
        renderer.render(scene, camera);
    };

    ump3Dintro.initSceneOne.initScene = function (idscene) {
        console.log('initScene: ', idscene);
        container = document.getElementById('threedscene-' + idscene);

        // scene
        scene = new THREE.Scene();

        // camera 

        camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 1000);
        camera.position.set(0, 10, 10);
        scene.add(camera);

        //material
        var diffuseColor = new THREE.Color(0xaaaaaa);
        var specularColor = new THREE.Color(0xcccccc);
        var material = new THREE.MeshPhongMaterial({
            color: diffuseColor,
            specular: specularColor,
            shininess: 5,
        });


        // light
        var ambientLight = new THREE.AmbientLight(0x333333, 1);
        scene.add(ambientLight);

        var spotLight2 = new THREE.SpotLight(0xe1e1e1, 0.5);
        spotLight2.position.set(30, 40, 0);
        spotLight2.castShadow = true;
        spotLight2.shadowDarkness = 0.2;
        spotLight2.shadow.bias = 0.0001;
        spotLight2.angle = Math.PI / 4;
        spotLight2.penumbra = 0.05;
        spotLight2.decay = 2;
        spotLight2.distance = 1000;
        spotLight2.shadow.camera.near = 1;
        spotLight2.shadow.camera.far = 1000;
        spotLight2.shadow.mapSize.width = 1024;
        spotLight2.shadow.mapSize.height = 1024;
        camera.lookAt(scene.position);
        scene.add(spotLight2);

        var hemiLight = new THREE.HemisphereLight(0xdfdfdf, 0x000000, 0.8);
        hemiLight.position.set(0, 500, 0);
        scene.add(hemiLight);

        // model

        var onProgress = function (xhr) {

            if (xhr.lengthComputable) {

                var percentComplete = xhr.loaded / xhr.total * 100;
                console.log(Math.round(percentComplete, 2) + '% downloaded');
                if (Math.round(percentComplete, 2) === 100) {
                    setTimeout(function () {
                        console.log('ump3Dintro: ', ump3Dintro);
                        ump3Dintro.initSceneOne.animate();


                    }, 1);
                }
            }

        };

        var onError = function () { };

        var manager = new THREE.LoadingManager();
        manager.addHandler(/\.dds$/i, new DDSLoader());

        // comment in the following line and import TGALoader if your asset uses TGA textures
        // manager.addHandler( /\.tga$/i, new TGALoader() );

        new OBJLoader(manager)
            .setPath('/ump-local/3d/')
            .load(idscene + '.obj', function (object) {

                var objBbox = new THREE.Box3().setFromObject(object);
                var bboxCenter = objBbox.getCenter().clone();
                bboxCenter.multiplyScalar(-1);

                object.traverse(function (node) {

                    if (node.isMesh) {
                        node.material = material;
                        node.geometry.translate(bboxCenter.x, bboxCenter.y, bboxCenter.z);
                    }

                });
                object01 = object;
                object01.position.set(0, 0, 0);
                var size = 0.8;
                if (window.matchMedia("(max-device-width:480px)").matches) {
                    size = 0.35;
                }
                object01.scale.set(size, size, size);
                scene.add(object01);
                objects3D[0] = object01;

            }, onProgress, onError);

        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);
        container.appendChild(renderer.domElement);
        //
        window.addEventListener('resize', onWindowResize3D, false);

        $("#threedscene-one").bind('touchmove', function (e) {
            onMouseMove(e.originalEvent.touches[0].clientX, object01);
        });

        window.addEventListener('mousemove', function (e) {
            onMouseMove(e.clientX, object01);
        }, false);
    };

    function onMouseMove(_clientX, _object01) {
        var mouseX = _clientX;
        var posX = ((mouseX / (windowHalfX)) * 100) - 100;
        object01.rotation.z = posX / 100;

    }

    function onWindowResize3D() {
        console.log('onWindowResize3D : ');

        windowHalfX = window.innerWidth / 2;
        windowHalfY = window.innerHeight / 2;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(window.innerWidth, window.innerHeight);
    }



    ump3Dintro.initSceneOne.initScene('one');
};

ump3Dintro.initSceneTwo = function () {
    console.log('initSceneTwo: ');
    var container;
    var camera, scene, renderer, controls;
    var object01;
    var mesh;
    var windowHalfX = window.innerWidth / 2;
    var windowHalfY = window.innerHeight / 2;

    ump3Dintro.initSceneTwo.animate = function () {
        if (ump3Dintro.playAnimation) {
            requestAnimationFrame(ump3Dintro.initSceneTwo.animate);
            ump3Dintro.initSceneTwo.render();
        }
    };

    ump3Dintro.initSceneTwo.render = function () {
        object01.rotation.y += 0.015;
        renderer.render(scene, camera);
    };

    ump3Dintro.initSceneTwo.initScene = function (idscene) {
        console.log('initScene: ', idscene);
        container = document.getElementById('threedscene-' + idscene);

        // scene
        scene = new THREE.Scene();

        // camera 

        camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 1000);
        camera.position.set(0, 10, 10);
        scene.add(camera);

        //material
        var diffuseColor = new THREE.Color(0xaaaaaa);
        var specularColor = new THREE.Color(0xcccccc);
        var material = new THREE.MeshPhongMaterial({
            color: diffuseColor,
            specular: specularColor,
            shininess: 5,
        });


        // light
        var ambientLight = new THREE.AmbientLight(0x333333, 1);
        scene.add(ambientLight);

        var spotLight2 = new THREE.SpotLight(0xe1e1e1, 0.5);
        spotLight2.position.set(30, 40, 0);
        spotLight2.castShadow = true;
        spotLight2.shadowDarkness = 0.2;
        spotLight2.shadow.bias = 0.0001;
        spotLight2.angle = Math.PI / 4;
        spotLight2.penumbra = 0.05;
        spotLight2.decay = 2;
        spotLight2.distance = 1000;
        spotLight2.shadow.camera.near = 1;
        spotLight2.shadow.camera.far = 1000;
        spotLight2.shadow.mapSize.width = 1024;
        spotLight2.shadow.mapSize.height = 1024;
        camera.lookAt(scene.position);
        scene.add(spotLight2);

        var hemiLight = new THREE.HemisphereLight(0xdfdfdf, 0x000000, 0.8);
        hemiLight.position.set(0, 500, 0);
        scene.add(hemiLight);


        // model

        var onProgress = function (xhr) {

            if (xhr.lengthComputable) {

                var percentComplete = xhr.loaded / xhr.total * 100;
                console.log(Math.round(percentComplete, 2) + '% downloaded');
                if (Math.round(percentComplete, 2) === 100) {
                    setTimeout(function () {
                        ump3Dintro.initSceneTwo.animate();
                    }, 1);
                }
            }

        };

        var onError = function () { };

        var manager = new THREE.LoadingManager();
        manager.addHandler(/\.dds$/i, new DDSLoader());

        // comment in the following line and import TGALoader if your asset uses TGA textures
        // manager.addHandler( /\.tga$/i, new TGALoader() );

        new OBJLoader(manager)
            .setPath('/ump-local/3d/')
            .load(idscene + '.obj', function (object) {

                var objBbox = new THREE.Box3().setFromObject(object);
                var bboxCenter = objBbox.getCenter().clone();
                bboxCenter.multiplyScalar(-1);

                object.traverse(function (node) {

                    if (node.isMesh) {
                        node.material = material;
                        node.geometry.translate(bboxCenter.x, bboxCenter.y, bboxCenter.z);
                    }

                });
                object01 = object;
                object01.position.set(0, 0, 0);
                object01.scale.set(0, 0, 0);
                scene.add(object01);
                objects3D[1] = object01;

            }, onProgress, onError);

        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);
        container.appendChild(renderer.domElement);
        console.log('container: ', container);
        //
        window.addEventListener('resize', onWindowResize3D, false);

        $("#threedscene-two").bind('touchmove', function (e) {
            onMouseMove(e.originalEvent.touches[0].clientX, object01);
        });

        window.addEventListener('mousemove', function (e) {
            onMouseMove(e.clientX, object01);
        }, false);
    }
    function onMouseMove(_clientX, _object01) {
        var mouseX = _clientX;
        var posX = ((mouseX / (windowHalfX)) * 100) - 100;
        object01.rotation.z = posX / 100;

    }

    function onWindowResize3D() {
        console.log('onWindowResize3D : ');

        windowHalfX = window.innerWidth / 2;
        windowHalfY = window.innerHeight / 2;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(window.innerWidth, window.innerHeight);
    }



    ump3Dintro.initSceneTwo.initScene('two');
};

ump3Dintro.initSceneThree = function () {
    console.log('initSceneThree: ');
    var container;
    var camera, scene, renderer, controls;
    var object01;
    var mesh;
    var windowHalfX = window.innerWidth / 2;
    var windowHalfY = window.innerHeight / 2;

    ump3Dintro.initSceneThree.animate = function () {
        if (ump3Dintro.playAnimation) {
            requestAnimationFrame(ump3Dintro.initSceneThree.animate);
            ump3Dintro.initSceneThree.render();
        }
    };

    ump3Dintro.initSceneThree.render = function () {
        object01.rotation.y += 0.030;
        renderer.render(scene, camera);
    };

    ump3Dintro.initSceneThree.initScene = function (idscene) {
        console.log('initScene: ', idscene);
        container = document.getElementById('threedscene-' + idscene);

        // scene
        scene = new THREE.Scene();

        // camera 

        camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 1000);
        camera.position.set(0, 10, 10);
        scene.add(camera);

        //material
        var diffuseColor = new THREE.Color(0xaaaaaa);
        var specularColor = new THREE.Color(0xcccccc);
        var material = new THREE.MeshPhongMaterial({
            color: diffuseColor,
            specular: specularColor,
            shininess: 5,
        });


        // light
        var ambientLight = new THREE.AmbientLight(0x333333, 1);
        scene.add(ambientLight);

        var spotLight2 = new THREE.SpotLight(0xe1e1e1, 0.5);
        spotLight2.position.set(30, 40, 0);
        spotLight2.castShadow = true;
        spotLight2.shadowDarkness = 0.2;
        spotLight2.shadow.bias = 0.0001;
        spotLight2.angle = Math.PI / 4;
        spotLight2.penumbra = 0.05;
        spotLight2.decay = 2;
        spotLight2.distance = 1000;
        spotLight2.shadow.camera.near = 1;
        spotLight2.shadow.camera.far = 1000;
        spotLight2.shadow.mapSize.width = 1024;
        spotLight2.shadow.mapSize.height = 1024;
        camera.lookAt(scene.position);
        scene.add(spotLight2);

        var hemiLight = new THREE.HemisphereLight(0xdfdfdf, 0x000000, 0.8);
        hemiLight.position.set(0, 500, 0);
        scene.add(hemiLight);


        // model

        var onProgress = function (xhr) {

            if (xhr.lengthComputable) {

                var percentComplete = xhr.loaded / xhr.total * 100;
                console.log(Math.round(percentComplete, 2) + '% downloaded');
                if (Math.round(percentComplete, 2) === 100) {
                    setTimeout(function () {
                        ump3Dintro.initSceneThree.animate();
                        initAll3D = true;
                    }, 1);
                }
            }

        };

        var onError = function () { };

        var manager = new THREE.LoadingManager();
        manager.addHandler(/\.dds$/i, new DDSLoader());

        // comment in the following line and import TGALoader if your asset uses TGA textures
        // manager.addHandler( /\.tga$/i, new TGALoader() );

        new OBJLoader(manager)
            .setPath('/ump-local/3d/')
            .load(idscene + '.obj', function (object) {

                var objBbox = new THREE.Box3().setFromObject(object);
                var bboxCenter = objBbox.getCenter().clone();
                bboxCenter.multiplyScalar(-1);

                object.traverse(function (node) {

                    if (node.isMesh) {
                        node.material = material;
                        node.geometry.translate(bboxCenter.x, bboxCenter.y, bboxCenter.z);
                    }

                });
                object01 = object;
                object01.position.set(0, 0, 0);
                object01.scale.set(0, 0, 0);
                scene.add(object01);
                objects3D[2] = object01;
            }, onProgress, onError);

        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);
        container.appendChild(renderer.domElement);
        //
        window.addEventListener('resize', onWindowResize3D, false);

        $("#threedscene-three").bind('touchmove', function (e) {
            onMouseMove(e.originalEvent.touches[0].clientX, object01);
        });

        window.addEventListener('mousemove', function (e) {
            onMouseMove(e.clientX, object01);
        }, false);
    }
    function onMouseMove(_clientX, _object01) {
        var mouseX = _clientX;
        var posX = ((mouseX / (windowHalfX)) * 100) - 100;
        object01.rotation.z = posX / 100;

    }


    function onWindowResize3D() {
        console.log('onWindowResize3D : ');

        windowHalfX = window.innerWidth / 2;
        windowHalfY = window.innerHeight / 2;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(window.innerWidth, window.innerHeight);
    }

    ump3Dintro.initSceneThree.initScene('three');
};